// jshint esversion: 8
export default {
  data: []
};
